module.exports = __webpack_public_path__ + "img/gc_moyen_1809.bf467300.jpg";